module.exports = __webpack_public_path__ + "static/media/water.e980c619.svg";